/* eslint-disable strict */
"use client";
import React from "react";
import { HttpLink, ApolloLink } from "@apollo/client";
import {
  ApolloNextAppProvider,
  ApolloClient,
  SSRMultipartLink,
  InMemoryCache,
} from "@apollo/client-integration-nextjs";

const createClient = (
  jwt: string | undefined,
  hermesURL?: string,
  clientName?: string,
  hermesToken?: string
) => {
  const httpLink = new HttpLink({
    uri: "/query",
    fetchOptions: { cache: "no-store" },
    credentials: "include",
    headers: {
      authorization: `Bearer ${jwt}`,
      "Content-Type": "application/json",
    },
  });
  const httpHermesLink = new HttpLink({
    uri: "/queryhermes",
    fetchOptions: { cache: "no-store" },
    credentials: "include",
    headers: {
      authorization: `Bearer ${hermesToken}`,
      "Content-Type": "application/json",
    },
  });
  return new ApolloClient({
    cache: new InMemoryCache(),
    link:
      typeof window === "undefined"
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: true,
            }),
            new HttpLink({
              uri: clientName
                ? process.env.HERMES_URL + "/queryhermes"
                : process.env.GRAPHQL_URL,
              fetchOptions: { cache: "no-store" },
              credentials: "include",
              headers: {
                authorization: `Bearer ${clientName ? hermesToken : jwt}`,
                "Content-Type": "application/json",
              },
            }),
          ])
        : ApolloLink.split(
            (operation) => operation.getContext().clientName === "hermes",
            httpHermesLink, //if above
            httpLink
          ),
  });
};

export const ApolloWrapper = ({
  children,
  jwt,
  clientName,
  hermesToken,
  hermesURL,
}: React.PropsWithChildren<{
  jwt: string | undefined;
  clientName?: string;
  hermesToken?: string;
  hermesURL?: string;
}>) => {
  const makeClient = React.useCallback(
    () => createClient(jwt, hermesURL, clientName, hermesToken),
    [clientName, hermesToken, hermesURL, jwt]
  );
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );
};
